<template>
  <div class="container invoice-table">
    <br>
    <h5>Дебиторка</h5>
    <div class="container">
      <div class="row">
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="year"
                    @change="search"
                    class="form-control"
                    aria-label="Год"
                    aria-describedby="basic-addon2">
              <option v-for="item in years" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="month"
                    @change="search"
                    class="form-control"
                    aria-label="Месяц"
                    aria-describedby="basic-addon2">
              <option v-for="item in months" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 140px">
            <select v-model="landCountryID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Страна"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.landCountries" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 210px">
            <select v-model="managerID"
                    @change="switchManager"
                    class="form-control"
                    aria-label="Менеджер"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.managers" :value="item.id">{{ item.display_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 160px">
            <select v-model="isIrretrievableDebt"
                    @change="switchManager"
                    class="form-control"
                    aria-label="Тип"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.type" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>

    <div>
      <table class="table table-sm text-left">
        <thead>
        <th class="manager-td-width"></th>
        <th class="text-right invoice-table-td-small">Общая</th>
        <th class="text-right invoice-table-td-small">Отправленная</th>
        <th class="text-right invoice-table-td-small">Подписанная</th>
        <th class="text-right invoice-table-td-small">Просроченная</th>
        <th class="text-right invoice-table-td-small">
          <input
              type="date"
              placeholder="yyyy-mm-dd"
              v-model="maxDate"
              @change="search">
        </th>
        </thead>
        <tbody>
        <template v-for="(customers, cust_idx) in arrears">
          <tr>
            <td @click="showCustomerChildren(customers.CustomerID, cust_idx)" class="cursor-pointer">
              {{ customers.CustomerName }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(customers.DebtSum))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(customers.DebtSumSent))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(customers.DebtSumSigned))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(customers.DebtSumOverdue))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(customers.DebtSumCustom))
              }}
            </td>
          </tr>
          <template v-if="customers.ShowChildren" v-for="(dep, dep_idx) in customers.items">
            <tr>
              <td @click="showDepartmentChildren(dep.DepartmentID, cust_idx, dep_idx)"
                  class="cursor-pointer td-padding-left-1">
                {{ dep.DepartmentName }}
              </td>
              <td class="text-right">
                {{ new Intl.NumberFormat('ru-ru').format(Math.round(dep.DebtSum)) }}
              </td>
              <td class="text-right">
                {{ new Intl.NumberFormat('ru-ru').format(Math.round(dep.DebtSumSent)) }}
              </td>
              <td class="text-right">
                {{ new Intl.NumberFormat('ru-ru').format(Math.round(dep.DebtSumSigned)) }}
              </td>
              <td class="text-right">
                {{ new Intl.NumberFormat('ru-ru').format(Math.round(dep.DebtSumOverdue)) }}
              </td>
              <td class="text-right">
                {{ new Intl.NumberFormat('ru-ru').format(Math.round(dep.DebtSumCustom)) }}
              </td>
            </tr>
            <template v-if="dep.ShowChildren" v-for="(br, BranchIDx) in dep.items">
              <tr>
                <td @click="showBranchChildren(dep.DepartmentID, cust_idx, dep_idx, BranchIDx)"
                    class="cursor-pointer td-padding-left-2">
                  {{ br.BranchName }}
                </td>
                <td class="text-right">
                  {{ new Intl.NumberFormat('ru-ru').format(Math.round(br.DebtSum)) }}
                </td>
                <td class="text-right">
                  {{ new Intl.NumberFormat('ru-ru').format(Math.round(br.DebtSumSent)) }}
                </td>
                <td class="text-right">
                  {{ new Intl.NumberFormat('ru-ru').format(Math.round(br.DebtSumSigned)) }}
                </td>
                <td class="text-right">
                  {{ new Intl.NumberFormat('ru-ru').format(Math.round(br.DebtSumOverdue)) }}
                </td>
                <td class="text-right">
                  {{ new Intl.NumberFormat('ru-ru').format(Math.round(br.DebtSumCustom)) }}
                </td>
              </tr>
              <template v-if="br.ShowChildren" v-for="(inv) in br.items">
                <tr>
                  <td class="cursor-pointer td-padding-left-3 text-nowrap">
                    <router-link :to="{name: 'invoiceItem', params:{
                                                doc_id: inv.ExternalID,
                                                countryID: inv.CountryID,
                                            }}" target="_blank">{{ inv.Number ? inv.Number : inv.ExternalID }}
                    </router-link>
                    от {{ inv.DocDate.substring(0, 10) }} {{ statusList[inv.Status] }}
                    <span v-if="inv.PaymentRemindersCount>0">({{ inv.PaymentRemindersCount }})</span>
                    <span v-if="inv.Comment != null"><br>{{ inv.Comment }}</span>
                  </td>
                  <td class="text-right">
                    {{ new Intl.NumberFormat('ru-ru').format(Math.round(inv.DebtSum)) }}
                  </td>
                  <td class="text-right">
                    {{ new Intl.NumberFormat('ru-ru').format(Math.round(inv.DebtSumSent)) }}
                  </td>
                  <td class="text-right">
                    {{ new Intl.NumberFormat('ru-ru').format(Math.round(inv.DebtSumSigned)) }}
                  </td>
                  <td class="text-right">
                    {{ new Intl.NumberFormat('ru-ru').format(Math.round(inv.DebtSumOverdue)) }}
                  </td>
                  <td class="text-right">
                    {{ new Intl.NumberFormat('ru-ru').format(Math.round(inv.DebtSumCustom)) }}
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
        <tr>
          <td></td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(totalDebt))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(totalDebtSent))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(totalDebtSigned))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(totalDebtOverdue))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(totalDebtCustom))
            }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

var today = new Date();

var this_year = today.getFullYear();
var this_month = today.getMonth();

this_month = this_month + 1;

// let tDate = new Date();
// tDate.setDate(tDate.getDate() + 1);
// const nextDay = tDate;

function compare(a, b) {
  if (a.DebtSum > b.DebtSum)
    return -1;
  if (a.DebtSum < b.DebtSum)
    return 1;
  return 0;
}


export default {
  name: 'Arrears',
  data() {
    return {
      years: [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      message: "",
      year: this_year,
      month: this_month,
      countryID: "ru",
      landCountryID: "Russia",
      managerID: 0,
      isIrretrievableDebt: false,
      maxDate: today.toISOString().split('T')[0],
      arrears: [],
      managers: [{id: 0, display_name: "Все"}],
      type: [{id: false, name: "Текущая"}, {id: true, name: "Невозвратная"}],
      statusList: {
        1: "Подготовлен",
        2: "Создан",
        3: "На согласовании",
        4: "Согласован",
        5: "Не согласован",
        6: "Отправлен",
        7: "Подписан",
        8: "Отклонен",
      },
    }
  },

  methods: {
    search() {
      axios.get('/arrears', {
        params: {
          year: this.year,
          month: this.month,
          land_country_id: this.landCountryID,
          manager_id: this.managerID,
          maxDate: this.maxDate,
          isIrretrievableDebt: this.isIrretrievableDebt,
        },
      })
          .then((res) => {
            // console.log(res.data);

            res.data.forEach(function (element) {
              element.ShowChildren = false;
              element.items = [];
            });

            this.arrears = res.data;

          })
          .catch(error => {
            console.log(`Error: ${error}`);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });


    },

    getManagers() {

      let landCountry = this.$store.getters.landCountries.find(({id}) => id === this.landCountryID);
      this.countryID = landCountry.parentCountry;

      axios.get('/managers', {
        params: {
          country_id: this.countryID,
          // country_id: 'ru',
        },
      })
          .then((res) => {
            // console.log(res.data);

            res.data.unshift({id: 0, display_name: "Все"});
            this.managers = res.data;

            // console.log(this.managers);

          })
          .catch(error => {
            console.log(`Error: ${error}`);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    showCustomerChildren(customerID, m_idx) {

      this.arrears[m_idx].items = [];

      if (this.arrears[m_idx].ShowChildren === false) {
        this.arrears[m_idx].ShowChildren = true;

        axios.get('/arrears_by_customer', {
          params: {
            land_country_id: this.landCountryID,
            customer_id: customerID,
            year: this.year,
            month: this.month,
            manager_id: this.managerID,
            maxDate: this.maxDate,
            isIrretrievableDebt: this.isIrretrievableDebt,
          },
        })
            .then((res) => {
              // console.log(res.data);

              let deps = [];

              res.data.forEach(function (element) {

                let dep_idx = deps.findIndex(el => el.DepartmentID === element.DepartmentID);
                // console.log("dep_idx=" + dep_idx);

                if (dep_idx === -1) {
                  deps.push({
                    DepartmentID: element.DepartmentID,
                    DepartmentName: element.DepartmentName,
                    DebtSum: 0.0,
                    DebtSumOverdue: 0.0,
                    DebtSumCustom: 0.0,
                    DebtSumSigned: 0.0,
                    DebtSumSent: 0.0,
                    items: [],
                    ShowChildren: false,
                  });

                  dep_idx = deps.findIndex(el => el.DepartmentID === element.DepartmentID);

                  // console.log("new dep");
                  //     console.log(deps[dep_idx]);

                }

                let br_idx = deps[dep_idx].items.findIndex(el => el.BranchID === element.BranchID);
                // console.log("br_idx=" + br_idx);

                if (br_idx === -1) {

                  deps[dep_idx].items.push({
                    BranchID: element.BranchID,
                    BranchName: element.BranchName,
                    DebtSum: 0.0,
                    DebtSumOverdue: 0.0,
                    DebtSumCustom: 0.0,
                    DebtSumSigned: 0.0,
                    DebtSumSent: 0.0,
                    items: [],
                    ShowChildren: false,
                  });

                  br_idx = deps[dep_idx].items.findIndex(el => el.BranchID === element.BranchID);

                  // console.log("new branch");
                  //
                  // if (element.external_id == 37241) {
                  //     console.log(deps[dep_idx].items);
                  // }
                }


                // console.log("going to push element");

                deps[dep_idx].items[br_idx].items.push(element);

                deps[dep_idx].items[br_idx].DebtSum += element.DebtSum;
                deps[dep_idx].items[br_idx].DebtSumOverdue += element.DebtSumOverdue;
                deps[dep_idx].items[br_idx].DebtSumCustom += element.DebtSumCustom;
                deps[dep_idx].items[br_idx].DebtSumSigned += element.DebtSumSigned;
                deps[dep_idx].items[br_idx].DebtSumSent += element.DebtSumSent;

                deps[dep_idx].DebtSum += element.DebtSum;
                deps[dep_idx].DebtSumOverdue += element.DebtSumOverdue;
                deps[dep_idx].DebtSumCustom += element.DebtSumCustom;
                deps[dep_idx].DebtSumSigned += element.DebtSumSigned;
                deps[dep_idx].DebtSumSent += element.DebtSumSent;

                // if (element.external_id == 37241) {
                //
                //     console.log(element);
                //     console.log(deps[dep_idx]);
                //     console.log(deps[dep_idx].items[br_idx]);
                // }

                // element.items = [];
              });

              deps.sort(compare);
              deps.forEach(function (item, idx) {
                deps[idx].items.sort(compare);
              });

              // console.log(deps);
              this.arrears[m_idx].items = deps;


              // this.arrears[m_idx].items = res.data;

            })
            .catch(error => {
              console.log(`Error: ${error}`);
              this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
            });
      } else {
        this.arrears[m_idx].ShowChildren = false;
      }
    },

    showDepartmentChildren(customerId, customer_idx, dep_idx) {

      console.log(customer_idx);
      console.log(dep_idx);
      console.log(this.arrears[customer_idx].items[dep_idx].ShowChildren);

      if (this.arrears[customer_idx].items[dep_idx].ShowChildren === false) {
        this.arrears[customer_idx].items[dep_idx].ShowChildren = true;
      } else {
        this.arrears[customer_idx].items[dep_idx].ShowChildren = false;
      }

      console.log(this.arrears[customer_idx].items[dep_idx].ShowChildren);
    },

    showBranchChildren(customerId, customer_idx, dep_idx, BranchIDx) {

      if (this.arrears[customer_idx].items[dep_idx].items[BranchIDx].ShowChildren === false) {
        this.arrears[customer_idx].items[dep_idx].items[BranchIDx].ShowChildren = true;
      } else {
        this.arrears[customer_idx].items[dep_idx].items[BranchIDx].ShowChildren = false;
      }
    },

    switchCountry() {
      localStorage.setItem('landCountryID', this.landCountryID);
      // this.$router.push({name: 'sales', params: {country_id: this.countryId}});
      this.getManagers();
      this.search();
    },

    switchManager() {
      this.search();
    }

  },

  computed: {
    totalDebt: function () {
      return this.arrears ? this.arrears.map(el => el.DebtSum).reduce((a, b) => a + b, 0) : 0;
    },
    totalDebtOverdue: function () {
      return this.arrears ? this.arrears.map(el => el.DebtSumOverdue).reduce((a, b) => a + b, 0) : 0;
    },
    totalDebtCustom: function () {
      return this.arrears ? this.arrears.map(el => el.DebtSumCustom).reduce((a, b) => a + b, 0) : 0;
    },
    totalDebtSigned: function () {
      return this.arrears ? this.arrears.map(el => el.DebtSumSigned).reduce((a, b) => a + b, 0) : 0;
    },
    totalDebtSent: function () {
      return this.arrears ? this.arrears.map(el => el.DebtSumSent).reduce((a, b) => a + b, 0) : 0;
    },
  }
  ,

  beforeCreate() {
    axios.defaults.headers.authorization = this.$store.state.token;
  }
  ,

  created() {

    // this.planDate.setDate(this.planDate + 1);

    document.title = 'Дебиторка';
    let landCountryID = localStorage.getItem('landCountryID');

    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "Russia";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    this.getManagers();
    this.search();
  }
  ,

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
  width: 1050px;
}

.invoice-table-td-medium {
  width: 95px;
}

.invoice-table-td-small {
  width: 60px;
}

.table-td-input {
  width: 70px;
}

.invoice-table-tr-height {
  vertical-align: middle;
  height: 36px;
}

.vertical-align-middle {
  vertical-align: middle;
}

.manager-td-width {
  width: 330px;
}

.td-padding-left-1 {
  padding-left: 40px;
}

.td-padding-left-2 {
  padding-left: 80px;
}

.td-padding-left-3 {
  padding-left: 120px;
}

.td-padding-left-4 {
  padding-left: 230px;
}

.no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  -moz-appearance: textfield !important;
}

</style>
